export const GAP_BETWEEN_ITEMS = 24;
export const CARD_ITEM_SETTINGS = {
    sm: {
        width: '328px',
    },
    md: {
        width: '438px',
    },
    lg: {
        width: '432px',
    },
};
export const PART_URL_GOOGLE_MAP_PLACE = 'https://www.google.com/maps/dir';
export const GOOGLE_API_VERSION = 'api=1';
export const MAILTO_PREFIX = 'mailto';
export const TEL_PREFIX = 'tel';
